import { Link } from 'react-router-dom';

export default function CtaSection() {
  return (
    <section className="relative flex flex-col md:flex-row min-h-[420px] md:min-h-[500px]">
      <div className="relative w-full md:w-1/2 min-h-[280px] md:min-h-[500px] overflow-hidden bg-secondary-50">
        <img
          src="https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20art%20collage%2C%20colorful%20comic%20scenes%20mosaic%2C%20warm%20coral%20and%20cream%20tones%2C%20vibrant%20illustrations%2C%20digital%20art%20collection%2C%20soft%20abstract%20background%2C%20creative%20layout%2C%20modern%20design%20aesthetic&width=1200&height=800&seq=cta-bg-left-01&orientation=landscape"
          alt="韩漫漫画网 - 精彩漫画世界"
          title="韩漫漫画网 - 加入百万读者"
          className="w-full h-full object-cover"
        />
        <div className="absolute top-6 left-6">
          <p className="text-xs text-foreground-500 font-medium">🎯 现在就开始</p>
        </div>
        <div className="absolute bottom-8 left-6">
          <h2 className="font-heading text-3xl md:text-5xl text-foreground-950 leading-tight">
            加入百万<br />读者行列<br />
            <span className="text-primary-500">发现新喜好</span>
          </h2>
        </div>
      </div>

      <div className="w-full md:w-1/2 bg-background-50 flex flex-col items-center justify-center px-6 md:px-14 py-12 md:py-0">
        <h3 className="font-heading text-2xl md:text-3xl text-foreground-950 text-center mb-4">
          加入百万读者
        </h3>
        <p className="text-sm md:text-base text-foreground-600 text-center leading-relaxed max-w-md mb-8">
          韩漫漫画网汇聚了最全的韩国漫画资源，从恋爱甜宠到热血冒险，从悬疑推理到治愈日常，总有一部适合你。免费在线阅读，无需注册，即刻享受。
        </p>
        <Link
          to="/category/romance"
          className="px-8 py-3.5 bg-secondary-600 text-white rounded-full text-sm font-semibold whitespace-nowrap cursor-pointer hover:bg-secondary-700 transition-all inline-flex items-center gap-2 shadow-lg shadow-secondary-500/25"
        >
          立即探索热门漫画
          <span className="w-4 h-4 flex items-center justify-center"><i className="ri-arrow-right-line"></i></span>
        </Link>
      </div>
    </section>
  );
}